import React, { useEffect, useState } from 'react';
import { Icon } from '../components/Icons.jsx';

const SLIDES = [
  { id: 1, label: 'Hook', headline: 'Open a carousel\ncontent item', sub: 'Generated slides from the selected backend content will appear here.' },
];

export const CarouselEditor = ({ navigate, content, onContentUpdated, backTo = 'content' }) => {
  const [active, setActive] = useState(0);
  const [headline, setHeadline] = useState(buildSlides(content)[0].headline);
  const [sub, setSub] = useState(buildSlides(content)[0].sub);
  const [style, setStyle] = useState('Premium dark');
  const [format, setFormat] = useState('1:1');
  const [slides, setSlides] = useState(buildSlides(content));
  const previewBrand = content?.contentItem?.title || content?.contentItem?.topic || 'Dathent';

  useEffect(() => {
    const nextSlides = buildSlides(content);
    setSlides(nextSlides);
    setActive(0);
    setHeadline(nextSlides[0].headline);
    setSub(nextSlides[0].sub);
  }, [content]);

  const onSelect = (i) => {
    setActive(i);
    setHeadline(slides[i].headline);
    setSub(slides[i].sub);
  };

  const updateSlide = (field, val) => {
    setSlides(s => s.map((sl, i) => i === active ? { ...sl, [field]: val } : sl));
    if (field === 'headline') setHeadline(val);
    if (field === 'sub') setSub(val);
  };

  return (
    <div className="page carousel-page">
      <div className="row between" style={{marginBottom:18}}>
        <div className="row" style={{gap:12}}>
          <button className="btn btn-ghost" onClick={() => navigate(backTo)}>
            <Icon name="chev_l" size={14}/> Back
          </button>
          <div>
            <div className="row" style={{gap:8}}>
              <h2 className="h2">Edit carousel</h2>
              <span className="chip chip-violet"><Icon name="sparkles" size={11}/> Generated by AI</span>
            </div>
            <div className="muted" style={{fontSize:12.5, marginTop:2}}>Customize text, visuals, and slide order</div>
          </div>
        </div>
          <div className="row editor-actions-bar" style={{gap:8}}>
          <button className="btn" disabled={!content?.contentItem?.id}><Icon name="refresh" size={13}/> Regenerate in post editor</button>
          <button className="btn" disabled={!content?.contentItem?.id}>Save draft in editor</button>
          <button className="btn btn-primary" disabled><Icon name="calendar" size={13}/> Scheduler target picker soon</button>
        </div>
      </div>

      <div className="carousel-layout">
        {/* LEFT: slide list */}
        <div className="card carousel-list">
          <div className="card-header" style={{marginBottom:12}}>
            <h3 className="card-title" style={{fontSize:13}}>Slides</h3>
            <button className="btn btn-sm btn-ghost"><Icon name="plus" size={12}/></button>
          </div>
          <div className="col" style={{gap:6}}>
            {slides.map((s, i) => (
              <button key={s.id} className={'slide-row ' + (active === i ? 'on' : '')} onClick={() => onSelect(i)}>
                <span className="slide-num">{i + 1}</span>
                <div style={{textAlign:'left', flex:1, minWidth:0}}>
                  <div style={{fontWeight:600, fontSize:12}}>Slide {i + 1}</div>
                  <div className="muted" style={{fontSize:11}}>{s.label}</div>
                </div>
                <Icon name="drag" size={14}/>
              </button>
            ))}
            <button className="btn btn-ghost btn-sm" style={{justifyContent:'flex-start', marginTop:8}}>
              <Icon name="plus" size={12}/> Add slide
            </button>
          </div>
        </div>

        {/* MIDDLE: editor */}
        <div className="card carousel-editor">
          <div className="row between" style={{marginBottom:14}}>
            <div className="row" style={{gap:8}}>
              <span className="chip chip-violet">Slide {active + 1} · {slides[active].label}</span>
            </div>
            <button className="btn btn-sm btn-ghost"><Icon name="x" size={13}/></button>
          </div>

          <div className="form-section">
            <div className="label">Headline</div>
            <textarea className="field" value={headline} onChange={e => updateSlide('headline', e.target.value)} rows={3}/>
          </div>

          <div className="form-section">
            <div className="label">Subtext</div>
            <textarea className="field" value={sub} onChange={e => updateSlide('sub', e.target.value)} rows={2}/>
          </div>

          <div className="form-section">
            <div className="label">Visual style</div>
            <div className="style-grid">
              {['Premium dark','Clean white','Minimal','Bold viral','AI gradient'].map(s => (
                <button key={s} className={'style-chip ' + (style === s ? 'on' : '')} onClick={() => setStyle(s)}>
                  <div className={'style-thumb st-' + s.split(' ')[0].toLowerCase()}/>
                  <span style={{fontSize:11.5}}>{s}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="form-section">
            <div className="label">Format</div>
            <div className="seg">
              {['1:1','4:5','9:16'].map(f => (
                <button key={f} className={format === f ? 'on' : ''} onClick={() => setFormat(f)}>{f}</button>
              ))}
            </div>
          </div>

          <div className="ai-actions">
            <div className="label">AI actions</div>
            <div className="row" style={{gap:6, flexWrap:'wrap'}}>
              <button className="ai-action">✨ Make more viral</button>
              <button className="ai-action">📚 Make educational</button>
              <button className="ai-action">🎯 Stronger hook</button>
              <button className="ai-action">✂️ Shorter</button>
              <button className="ai-action">🔄 Rewrite slide</button>
            </div>
          </div>
        </div>

        {/* RIGHT: phone preview */}
        <div className="card carousel-preview-wrap">
          <div className="row between" style={{marginBottom:14}}>
            <h3 className="card-title" style={{fontSize:13}}>Instagram preview</h3>
            <span className="chip chip-violet">{active + 1} / {slides.length}</span>
          </div>
          <PhonePreview slides={slides} active={active} setActive={onSelect} style={style} brand={previewBrand}/>
          <div className="row" style={{gap:6, justifyContent:'center', marginTop:12}}>
            <button className="btn btn-icon btn-sm" onClick={() => onSelect(Math.max(0, active - 1))}><Icon name="chev_l" size={12}/></button>
            <button className="btn btn-icon btn-sm" onClick={() => onSelect(Math.min(slides.length - 1, active + 1))}><Icon name="chev_r" size={12}/></button>
          </div>
        </div>
      </div>
    </div>
  );
};

function buildSlides(content) {
  const version = content?.activeVersion;
  if (!version) return SLIDES;
  const platformText = Object.entries(version.platformVersions || {})
    .filter(([key, value]) => !String(key).startsWith('__') && typeof value === 'string' && value.trim())
    .map(([, value]) => value.trim())[0];
  const text = version.caption || version.body || platformText || version.hook || '';
  const chunks = text.split(/\n{2,}|\.\s+/).map(item => item.trim()).filter(Boolean).slice(0, 5);
  const source = chunks.length ? chunks : [version.hook || 'Generated carousel'];
  return source.map((chunk, index) => ({
    id: index + 1,
    label: index === 0 ? 'Hook' : `Slide ${index + 1}`,
    headline: chunk.length > 42 ? chunk.slice(0, 42) + '...' : chunk,
    sub: index === source.length - 1 ? (version.cta || 'Save this for later.') : (version.hashtags || []).slice(0, 3).join(' ') || 'Generated by Dathent.',
  }));
}

const PhonePreview = ({ slides, active, setActive, style, brand }) => {
  const slide = slides[active];
  const styleMap = {
    'Premium dark': { bg: 'linear-gradient(135deg, #2a1d4f, #6E5BFF)', text: '#fff', accent: '#E4B43F' },
    'Clean white': { bg: 'linear-gradient(135deg, #fafaf5, #ede9dc)', text: '#15161A', accent: '#C49628' },
    'Minimal': { bg: '#1a1d24', text: '#F5F7FA', accent: '#9CA3AF' },
    'Bold viral': { bg: 'linear-gradient(135deg, #FF6B35, #F7B731)', text: '#fff', accent: '#fff' },
    'AI gradient': { bg: 'linear-gradient(135deg, #6E5BFF, #E4B43F)', text: '#fff', accent: '#fff' },
  };
  const sty = styleMap[style] || styleMap['Premium dark'];

  return (
    <div className="phone-frame">
      <div className="phone-notch"/>
      <div className="phone-screen">
        <div className="ig-head">
          <div className="ig-avatar"/>
          <div style={{flex:1}}>
            <div style={{fontSize:11, fontWeight:600}}>{brand}</div>
            <div style={{fontSize:9, color:'#9CA3AF'}}>Preview</div>
          </div>
          <span style={{fontSize:14}}>⋯</span>
        </div>
        <div className="ig-slides">
          <div className="ig-slide" style={{background: sty.bg, color: sty.text}}>
            <div className="ig-slide-num" style={{borderColor: sty.accent + '50', color: sty.text}}>{active + 1}/{slides.length}</div>
            <div className="ig-headline" style={{color: sty.text}}>
              {slide.headline.split('\n').map((line, i) => <div key={i}>{line}</div>)}
            </div>
            <div className="ig-sub" style={{color: sty.text, opacity: 0.75}}>{slide.sub}</div>
            <div className="ig-brand" style={{color: sty.accent}}>{brand}</div>
          </div>
          <div className="ig-dots">
            {slides.map((_, i) => (
              <span key={i} onClick={() => setActive(i)} className={i === active ? 'on' : ''}/>
            ))}
          </div>
        </div>
        <div className="ig-actions">
          <Icon name="heart" size={20}/>
          <Icon name="msg" size={20}/>
          <Icon name="send" size={20}/>
          <span style={{flex:1}}/>
          <Icon name="bookmark" size={20}/>
        </div>
        <div style={{padding:'2px 12px 8px', fontSize:10}}>
          <span style={{fontWeight:600}}>Carousel preview</span>
        </div>
      </div>
    </div>
  );
};
